var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.876 1.987 7.661 8.806a.549.549 0 0 1-.837 0L.54 1.987C.284 1.665.263 1.23.493.917.74.591 1.134.595 1.377.86l5.831 6.364L13.04.86c.258-.278.652-.253.884.057.23.313.21.748-.048 1.07Z"
  })));
};
export default SvgIconArrowDown;